import { get, has, omit } from 'lodash-es'
import { KEY_SEPARATOR } from '@/components/shared-table/utils'

const propertyDisplayNameMap = {
  'logkow: octanol-water': 'Log K<sub>ow</sub>',
  'log k<sub>ow</sub>': 'Log K<sub>ow</sub>',
  'log kow': 'Log K<sub>ow</sub>',
  'logkow': 'Log K<sub>ow</sub>',
  'logp (log)': 'Log K<sub>ow</sub>',
  'vapor pressure at 25°c': 'Vapor Pressure',
  'vapor pressure': 'Vapor Pressure',
  'vp': 'Vapor Pressure',
  'normal boiling point': 'Boiling Point',
  'boiling point': 'Boiling Point',
  'mp': 'Melting Point',
  'bp': 'Boiling Point',
  'melting point': 'Melting Point',
  "henry's law constant": "Henry's Law Constant",
  'water solubility': 'Water Solubility',
  'water solubility at 25°c': 'Water Solubility',
  'wskowwin': 'Water Solubility',
  'waternt': 'Water Solubility',
  'ws': 'Water Solubility',
  'koa (log)': 'Log K<sub>OA</sub>',
  'log k<sub>oa</sub>': 'Log K<sub>OA</sub>',
  'koc (log)': 'Log K<sub>OC</sub>',
  'koc': 'Log K<sub>OC</sub>',
  'log k<sub>oc</sub>': 'Log K<sub>OC</sub>',
  'hl': "Henry's Law Constant",
}

const tryMapDisplayName = (name) => get(propertyDisplayNameMap, name?.trim()?.toLowerCase(), null)

const defaultChildren = [
  { id: 'experimental', name: 'Experimental', shortName: 'Exp.', hideInSelect: true },
  { id: 'predicted', name: 'Predicted', shortName: 'Pred.', hideInSelect: true },
]

const applyDefaultChildrenIfNoChildren = (group, defaultChildIds = []) => {
  const defaultChildrenToApply = defaultChildIds?.length
    ? defaultChildren.filter((child) => defaultChildIds.includes(child.id))
    : defaultChildren

  if (!has(group, 'children')) return { ...group, children: defaultChildrenToApply }

  if (has(group, 'children') && !group.children?.length) return omit(group, 'children')

  return group
}

const composeIdWithPrefix = (id, prefix) => {
  if (!id) console.warn('Warning. Missing id for child with parentId:', prefix)
  return `${prefix ? prefix + KEY_SEPARATOR : ''}${id}`
}

const buildMappedGroup = ({ id, name, children, idPrefix, ...rest } = {}) => {
  if (!id) {
    console.warn('buildMappedGroup requires id and name')
  }

  const mappedName = tryMapDisplayName(name)
  const composedId = composeIdWithPrefix(id, idPrefix)

  return {
    ...rest,
    id: composedId,
    name: mappedName ?? name,
    ...(mappedName ? { sourceName: name } : {}),
    ...(Array.isArray(children)
      ? {
          children: children.map((child) =>
            buildMappedGroup({
              ...child,
              idPrefix: composedId,
            }),
          ),
        }
      : {}),
  }
}

export { applyDefaultChildrenIfNoChildren, tryMapDisplayName, buildMappedGroup, defaultChildren }
